module.exports = __webpack_public_path__ + "public/img/Menyusun Laporan Keuangan dengan Microsoft Excel untuk Menjadi Staf Akuntan.2ddae7e6.png";